import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/components/ui/Logo/Logo';
import { styles } from './styles/Logo.styles';

export default function LogoSidenav() {
  return (
    <Link to="/">
      <Logo {...styles.img} />
    </Link>
  );
}
